<template>
  <div class="fondo2">
    <center>
      <h1 class="title">Para solicitar la facturación de Emirates</h1>
      <h3 class="is-size-5">
        <strong
          ><p>Favor de llenar el formato sin alterar los campos</p>
          <p>
            posteriormente enviar el archivo, anexar boletos en formato PDF y constancia de situación fiscal
          </p>
          <p>al correo de:</p>
          <p class="subtitle is-3">olivia.bonifacio@contravel.com.mx</p>
          <p>&nbsp;&nbsp;&nbsp;</p>
        </strong>
      </h3>
      <b-button
        class="mb-2"
        @click="Emirates('Emirates.zip')"
        type="is-info is-large"
        icon-right="package-down"
        ><center>
          <p>Descargar</p>
          formato Emirates
        </center>
      </b-button>
    </center>
    <div class="columnas" align="center">
      <div class="column card-header">
        <img style="52vw" src="@/assets/factura.jpg" />
      </div>
    </div>
  </div>
</template>

<script>
import Constantes from "@/Constantes";

export default {
  name: "Emirates",

  data() {
    return {};
  },
  mounted() {},
  methods: {
    async Emirates(zip) {
      const url = Constantes.URL_SERVIDOR + "/Emirates.php?zip=" + zip;
      window.open(url);
    },
  },
};
</script>

<style>
.fondo2 {
  background-color: rgba(80, 71, 71, 0.24);
}
.columnas {
  position: relative;
  top: 0.5vw;
  width: 20vw;
  left: 39vw;
}
</style>